exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-price[data-v-64d93df8]{font-size:24px;font-weight:700;line-height:32px}.transition-errors-enter[data-v-64d93df8],.transition-errors-leave-to[data-v-64d93df8]{height:0;margin:0;padding:0;opacity:0}.transition-errors-enter-active[data-v-64d93df8],.transition-errors-leave-active[data-v-64d93df8]{transition:all .3s}", ""]);

// exports
